import MainLayout from "../../layouts/MainLayout/MainLayout";
import { Route, Routes } from "react-router-dom";
import ViewLayout from "../../layouts/ViewLayout/ViewLayout";
import SalesHome from "../../features/Sales/SalesHome/SalesHome";
import SalesDiscounts from "../../features/Sales/SalesDiscounts/SalesDiscounts";
import SalesAcaUnitPriceContainer
    from "../../features/Sales/SalesAcademicUnitPrice/SalesAcaUnitPriceContainer/SalesAcaUnitPriceContainer";
import SalesPayments from "../../features/Sales/SalesPayments/SalesPaymentsContainer/SalesPayments";
import SalesBulkMessages from "../../features/Sales/SalesBulkMessages/SalesBulkMessages";
import SalesSubscriptions from "../../features/Sales/SalesSubscriptions/SalesSubscriptions";
import SalesLeadsContainer from "../../features/Sales/SalesLeadsContainer/SalesLeadsContainer";

import DollarValueFixed from "../../components/DollarValueFixed/DollarValueFixed";


const SalesLayout = ({ children }) => {
    return <>
        <DollarValueFixed />
        {children}
    </>
}

const Sales = () => {
    return (
        <MainLayout>
            <Routes>
                <Route
                    path='/'
                    element={
                        <ViewLayout
                            title='Ventas'
                            description='Aquí podras encontrar toda la información relacionada con el area de ventas de la plataforma.'
                            backBtnText='Ir a Ventas'
                            withBackButton
                        >
                            <SalesLayout>
                                <SalesHome />
                            </SalesLayout>
                        </ViewLayout>
                    }
                />
                <Route
                    path='/descuentos'
                    element={
                        <ViewLayout
                            title='Descuentos'
                            description='Aquí podras crear y controlar los descuentos de la plataforma.'
                            backBtnText='Ir a Ventas'
                            withBackButton
                        >
                            <SalesLayout>
                                <SalesDiscounts />
                            </SalesLayout>
                        </ViewLayout>
                    }
                />
                <Route
                    path='/pagos-ingresados'
                    element={
                        <ViewLayout
                            title='Gestión de inscripciones'
                            description='Aquí encontrarás todos los pedidos de inscripción así como la información de sus pagos asociados.'
                            backBtnText='Ir a Ventas'
                            withBackButton
                        >
                            <SalesLayout>
                                <SalesPayments />
                            </SalesLayout>

                        </ViewLayout>
                    }
                />
                <Route
                    path='/suscripciones'
                    element={
                        <ViewLayout
                            title='Gestión de suscripciones'
                            description='Aquí encontrarás todos los pedidos de suscripciones así como la información de sus pagos asociados.'
                            backBtnText='Ir a Ventas'
                            withBackButton
                        >
                            <SalesLayout>
                                <SalesSubscriptions />
                            </SalesLayout>

                        </ViewLayout>
                    }
                />
                < Route
                    path='/precios'
                    element={
                        <ViewLayout
                            title='Precios Unidades Académicas'
                            description='Modificar el monto en pesos y dolares de las unidades académicas existentes.'
                            backBtnText='Ir a Ventas'
                            withBackButton
                        >
                            <SalesLayout>
                                <SalesAcaUnitPriceContainer />
                            </SalesLayout>

                        </ViewLayout>
                    }
                />
                < Route
                    path='/mensajes-en-masa'
                    element={
                        <ViewLayout
                            title='Mensajes automáticos'
                            description='Utilizar el BOT para enviar mensajes en masa a leads'
                            backBtnText='Ir a Ventas'
                            withBackButton
                        >
                            <SalesLayout>
                                <SalesBulkMessages />
                            </SalesLayout>

                        </ViewLayout>
                    }
                />
                < Route
                    path='/prospectos'
                    element={
                        <ViewLayout
                            title='Prospectos'
                            description='Contactos que mostraron interés'
                            backBtnText='Ir a Ventas'
                            withBackButton
                        >
                            <SalesLayout>
                                <SalesLeadsContainer />
                            </SalesLayout>
                        </ViewLayout>
                    }
                />
            </Routes>
        </MainLayout>
    );
};
// export default Sales;
export default Sales
